module.exports = __webpack_public_path__ + "static/media/CU.a00cb8ec.png";